<script lang="ts">
	import PortfolioChartLoader from 'components/Portfolio/PortfolioChartLoader/PortfolioChartLoader.svelte';
	import ArrowDown from 'assets/svg/arrowDown.svg?component';

	export let dark: boolean;
	export let title: string;
</script>

<div class="chart-wrapper" class:dark>
	<div class="top-section">
		<div class="price-info">
			<p class="price">{title}</p>
		</div>
		<div class="wrapper" class:dark>
			<div class="scale-wrapper">
				<p class="selected-scale">24H</p>
				<ArrowDown class={`select-icon bottom ${dark ? 'dark' : ''}`} width={8} height={8} />
			</div>
		</div>
	</div>
	<div class="loading-wrapper">
		<PortfolioChartLoader {dark} isLoading={false} />
	</div>
</div>

<style lang="scss">
	@import 'chart';
	@import 'src/components/TimeScaleSelect/timeScaleSelect';
</style>
